/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:05cbf5f8-4c5e-4631-8c8b-9d605f83ad7e",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_AUCUkVyYI",
    "aws_user_pools_web_client_id": "6lhhp8i27jqfdnq0a0dpmipur3",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://ri7kndqmmrcpzfw4bfj77mrvba.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "amplifyFormAPI",
            "endpoint": "https://yf7vr6jji0.execute-api.ap-northeast-1.amazonaws.com/main",
            "region": "ap-northeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "arbrownpdffile43016-arbsip",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
